export enum Environment {
  Production = 'production',
  Staging = 'staging',
}
